// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"22db691c","437":"f3c0efad","455":"a6109696","761":"17982700"}[chunkId] + ".chunk.css";
};